import React from 'react'
import { Helmet } from 'react-helmet'
import { Result, Button } from 'antd'
import 'antd/lib/result/style'
import { useHistory } from 'react-router-dom'

const SystemLogout = () => {
  const history = useHistory()

  return (
    <>
      <Helmet title="Logout successful" />
      <Result
        status="success"
        title="Logout successful"
        subTitle="You have been logged out. See you soon!"
        extra={[
          <Button key="login" onClick={() => history.push('/login')}>
            Login again
          </Button>,
        ]}
      />
    </>
  )
}

export default {
  name: 'Logout',
  routeProps: {
    path: '/logout_successful',
    component: SystemLogout,
  },
}
